import React from 'react';
import { CardBody, CardContainer, CardHeader } from './styles';
import Heading from '../../shared/Heading';
import Text from '../../shared/Text';
import { Box, Stack } from '@mui/material';
import { useTotalDashRegistroSas } from '../../../pages/Dashboard/hooks/registroSas';
import { numberLocale } from '../../../../utils/mask';

interface ComparativeCardProps {
  title: string;
  total?: number;
}

export function ComparativeCardComp({ title, total }: ComparativeCardProps) {
  const { data: dataRegistroSas, isLoading: isLoadingRegistroSas } =
    useTotalDashRegistroSas('registros-sas', 'comparative');

  let data, isLoading;

  switch (title) {
    // case 'Acessos':
    //   // Suponha que você tem um hook para 'Acessos'
    //   ({ data, isLoading } = useTotalDashAcessos('acessos', 'comparative'));
    //   break;
    // case 'Atendimentos':
    //   // Suponha que você tem um hook para 'Atendimentos'
    //   ({ data, isLoading } = useTotalDashAtendimentos(
    //     'atendimentos-sse',
    //     'comparative'
    //   ));
    //   break;
    // case 'Usuários':
    //   ({ data, isLoading } = useTotalDashUsuarios('usuarios', 'comparative'));
    //   break;
    case 'Registro SAS':
      data = dataRegistroSas;
      isLoading = isLoadingRegistroSas;
      break;
  }

  return (
    <CardContainer>
      <CardHeader>
        <Box>
          <Text as="p" size="small" weight="normal">
            Comparativo
          </Text>
          <Heading as="h1" size="medium" color="black">
            {title}
          </Heading>
        </Box>
        {isLoading ? (
          <p>Carregando...</p>
        ) : (
          <Heading as="h1" size="large" color="blue">
            {numberLocale(data?.total)}
          </Heading>
        )}
      </CardHeader>

      <CardBody>
        <Box>
          <Text as="p" size="large" weight="bold" color="red">
            10%
          </Text>
          <Text as="p" size="medium" weight="semibold">
            Ontem
          </Text>
          <Text as="p" size="small" weight="normal">
            26 de Nov (2023)
          </Text>
        </Box>

        <Stack
          sx={{
            marginRight: '2rem',
            borderLeft: '1px solid rgba(143,144,166, 0.3)',
          }}
        >
          <Box sx={{ marginLeft: '0.7rem' }}>
            <Text as="p" size="large" weight="semibold" color="blue">
              Igual
            </Text>
            <Text as="p" size="medium" weight="semibold">
              Semana passada
            </Text>
            <Text as="p" size="small" weight="normal">
              16 de Nov (2023)
            </Text>
          </Box>
        </Stack>
      </CardBody>
    </CardContainer>
  );
}
